import { combineReducers, createStore, applyMiddleware } from "redux";
import multi from "redux-multi";
import thunk from "redux-thunk";

import {
  usuario,
  clientes,
  configuracoes,
  fidelidade_dashboard,
  fidelidade_mapa,
  fidelidade_resumo,
  cashback,
  comanda,
  produtos,
  categorias,
  categorias_produtos,
  complementos,
  entregadores,
  pedidos,
  delivery,
  usuarios,
  menus,
  pagamentos,
} from "src/store/reducers";

const devTools =
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();

const reducers = combineReducers({
  usuario,
  clientes,
  configuracoes,
  fidelidade_dashboard,
  fidelidade_mapa,
  fidelidade_resumo,
  cashback,
  comanda,
  produtos,
  categorias,
  categorias_produtos,
  complementos,
  entregadores,
  pedidos,
  delivery,
  usuarios,
  menus,
  pagamentos,
});

export default applyMiddleware(thunk, multi)(createStore)(
  reducers,
  process.env.NODE_ENV === "development" ? devTools : undefined
);
